import { useMemo } from "react";

import type { IntlShape } from "context/Intl";

import type { RegisterStep } from "./RegisterStepperProvider";

const KEY = "authentication.register";

export function useClientRegisterSteps(intl: IntlShape): RegisterStep[] {
    return useMemo(
        () => [
            {
                key: "services",
                label: intl.formatMessage(`${KEY}.client_flow.services.label`),
                title: intl.formatMessage(`${KEY}.client_flow.services.aside.title`),
                description: intl.formatMessage(`${KEY}.client_flow.services.aside.description`),
                footnote: true,
            },
            {
                key: "need",
                label: intl.formatMessage(`${KEY}.client_flow.need.label`),
                title: intl.formatMessage(`${KEY}.client_flow.need.aside.title`),
                description: intl.formatMessage(`${KEY}.client_flow.need.aside.description`),
                footnote: true,
            },
            /*{
                key: "frequency",
                label: intl.formatMessage(`${KEY}.client_flow.frequency.label`),
                title: intl.formatMessage(`${KEY}.client_flow.frequency.aside.title`),
                description: intl.formatMessage(`${KEY}.client_flow.frequency.aside.description`),
                footnote: true,
            },*/
            {
                key: "informations",
                label: intl.formatMessage(`${KEY}.client_flow.informations.label`),
                title: intl.formatMessage(`${KEY}.client_flow.informations.aside.title`),
                description: intl.formatMessage(`${KEY}.client_flow.informations.aside.description`),
                footnote: true,
            },
            {
                key: "cesu",
                label: intl.formatMessage(`${KEY}.client_flow.cesu.label`),
                title: intl.formatMessage(`${KEY}.client_flow.cesu.aside.title`),
                description: intl.formatMessage(`${KEY}.client_flow.cesu.aside.description`),
                footnote: true,
            },
            {
                key: "confirmation",
                label: intl.formatMessage(`${KEY}.client_flow.confirmation.label`),
                title: intl.formatMessage(`${KEY}.client_flow.confirmation.title`),
                description: intl.formatMessage(`${KEY}.client_flow.confirmation.description`),
                footnote: true,
            },
        ],
        [intl]
    );
}
